module.exports = __webpack_public_path__ + "static/media/suerte.8dd6020a.png";